import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { InfrastructureService } from "../../application/services/infrastructureService";

const infrastructureService = new InfrastructureService();

export const infrastructureKeys = {
  all: ["infrastructure"],
  vms: () => [...infrastructureKeys.all, "vms"],
  vm: (id) => [...infrastructureKeys.vms(), id],
  tags: () => [...infrastructureKeys.all, "tags"],
  tag: (id) => [...infrastructureKeys.tags(), id],
};

export const useInfrastructureCache = (options = {}) => {
  return useQuery({
    queryKey: infrastructureKeys.all,
    queryFn: async () => {
      const result = await infrastructureService.getAllInfrastructure();
      if (!result.success) {
        throw new Error(result.message);
      }
      return {
        vms: result.vms,
        tags: result.tags,
        vmTags: result.vmTags,
      };
    },
    staleTime: options.staleTime ?? 30 * 60 * 1000, // 30 minutes
    gcTime: options.gcTime ?? 60 * 60 * 1000, // 60 minutes
    refetchOnMount: options.refetchOnMount ?? false, // NO refetch on return
    refetchOnWindowFocus: options.refetchOnWindowFocus ?? false,
    refetchOnReconnect: options.refetchOnReconnect ?? false,
    retry: options.retry ?? 1,
    enabled: options.enabled ?? true,
    ...options,
  });
};

export const useRefreshInfrastructure = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const result = await infrastructureService.getAllInfrastructure();
      if (!result.success) throw new Error(result.message);
      return result;
    },
    onSuccess: (newData) => {
      queryClient.setQueryData(infrastructureKeys.all, {
        vms: newData.vms,
        tags: newData.tags,
        vmTags: newData.vmTags,
      });
    },
  });
};
